// Enum is ordered
export enum BoundaryCreateOptimizedStatus {
  ProcessingStarted = 'Processing Started',
  InitializingTerritories = 'Initializing Territories',
  BalancingTerritories = 'Balancing Territories',
  RebalancingTerritories = 'Rebalancing Territories',
  ProcessingFinished = 'Processing Finished',
  CalculatingStatistics = 'CalculatingStatistics',
  Finished = 'Finished',
}

export const INITIAL_BOUNDARY_CREATE_OPTIMIZED_STATUS = BoundaryCreateOptimizedStatus.ProcessingStarted;

export type BoundaryCreateOptimizedItem = {
  type: 'Maptive';
  hash: string;
  isFailed: boolean;
  status: BoundaryCreateOptimizedStatus;
  startedOnCurrentTab: boolean;
};

export type BoundaryCreateOptimizedState = Readonly<{
  pendingItems: ReadonlyArray<BoundaryCreateOptimizedItem>;
}>;
